<template>
  <form ref="form" class="form-register" @submit.prevent novalidate>
    <header class="form-header">
      <h2 class="form-header__subtitle">Insira os dados cadastrais</h2>
    </header>

    <div class="form-content">
      <div class="row">
        <FormControlInput
          class="col-12"
          icon="user"
          v-model.trim="items.name"
          label="Nome completo"
          id="name"
          name="name"
          data-vv-as="Nome completo"
          v-validate="'required'"
          :valid="!vErrors.has('name') && fields.name && fields.name.dirty && fields.name.valid"
          :error="vErrors.collect('name')"
        />
      </div>

      <div class="row">
        <FormControlMask
          class="col-6"
          v-model="items.cpf"
          type="tel"
          label="CPF"
          id="cpf"
          name="cpf"
          data-vv-as="CPF"
          v-validate="{ required: true, regex: /\d{11}/ }"
          mask="###.###.###-##"
          :valid="!vErrors.has('cpf') && fields.cpf && fields.cpf.dirty && fields.cpf.valid"
          :error="vErrors.collect('cpf')"
        />

        <FormControlInput
          class="col-6"
          v-model="items.rg"
          label="RG"
          id="rg"
          name="rg"
          data-vv-as="RG"
          v-validate="'required'"
          :valid="fields.rg && fields.rg.valid"
          :error="vErrors.collect('rg')"
        />
      </div>

      <div class="row">
        <FormControlMask
          class="col-6"
          v-model="items.birth"
          type="tel"
          label="Data de Nascimento"
          id="birth"
          name="birth"
          data-vv-as="Data de Nascimento"
          v-validate="'required|date_format:dd/MM/yyyy'"
          :masked="true"
          mask="##/##/####"
          :valid="!vErrors.has('birth') && fields.birth && fields.birth.dirty && fields.birth.valid"
          :error="vErrors.collect('birth')"
        />

        <FormControlSelect
          class="col-6"
          v-model="items.gender"
          :options="gender"
          :value="items.gender"
          label="Sexo"
          id="gender"
          name="gender"
          data-vv-as="Sexo"
          v-validate="'required'"
          :valid="
            !vErrors.has('gender') && fields.gender && fields.gender.dirty && fields.gender.valid
          "
          :error="vErrors.collect('gender')"
        />
      </div>

      <div class="row">
        <FormControlMask
          class="col-6"
          icon="phone-alt"
          v-model="items.phone"
          type="tel"
          label="Telefone"
          id="phone"
          name="phone"
          mask="(##) ####-####"
          data-vv-as="Telefone"
          v-validate="{ required: false, regex: /\d{10}/ }"
          :valid="!vErrors.has('phone') && fields.phone && fields.phone.dirty && fields.phone.valid"
          :error="vErrors.collect('phone')"
        />

        <FormControlMask
          v-model="items.celphone"
          id="celphone"
          type="tel"
          class="col-6"
          label="Celular"
          data-vv-as="Celular"
          name="celphone"
          icon="phone-alt"
          mask="(##) #####-####"
          v-validate="'required'"
          :valid="
            !vErrors.has('celphone') &&
              fields.celphone &&
              fields.celphone.dirty &&
              fields.celphone.valid
          "
          :error="vErrors.collect('celphone')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.email"
          id="email"
          type="email"
          name="email"
          class="col-6"
          label="E-mail"
          data-vv-as="E-mail"
          icon="envelope"
          v-validate="'required|email'"
          :valid="!vErrors.has('email') && fields.email && fields.email.dirty && fields.email.valid"
          :error="vErrors.collect('email')"
        />

        <FormControlMask
          @blur="searchCep"
          v-model="items.address.zipcode"
          id="address.cep"
          ref="address.zipcode"
          type="tel"
          name="zipcode"
          class="col-6"
          label="CEP"
          data-vv-as="CEP"
          mask="#####-###"
          icon="map-marker-alt"
          v-validate="'required'"
          :valid="fields.zipcode && fields.zipcode.valid"
          :error="vErrors.collect('cep')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.address.street"
          :value="items.address.street"
          id="street"
          ref="address.street"
          type="text"
          name="street"
          class="col-10"
          label="Endereço"
          data-vv-as="Endereço"
          v-validate="'required'"
          :valid="fields.street && fields.street.valid"
          :error="vErrors.collect('street')"
        />

        <FormControlInput
          v-model="items.address.number"
          id="number"
          ref="address.number"
          type="text"
          name="number"
          class="col-2"
          label="Número"
          data-vv-as="Número"
          v-validate="'required'"
          :valid="
            !vErrors.has('number') && fields.number && fields.number.dirty && fields.number.valid
          "
          :error="vErrors.collect('number')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.address.complementary"
          id="complementary"
          ref="address.complementary"
          type="text"
          name="complementary"
          class="col-6"
          label="Complemento"
          data-vv-as="Complemento"
          :valid="items.address.complementary"
          :error="vErrors.collect('complementary')"
        />

        <FormControlInput
          v-model="items.address.neighborhood"
          :value="items.address.neighborhood"
          id="neighborhood"
          ref="address.neighborhood"
          type="text"
          name="neighborhood"
          class="col-6"
          label="Bairro"
          data-vv-as="Bairro"
          v-validate="'required'"
          :valid="fields.neighborhood && fields.neighborhood.valid"
          :error="vErrors.collect('neighborhood')"
        />
      </div>

      <div class="row">
        <FormControlInput
          v-model="items.address.city"
          :value="items.address.city"
          ref="address.city"
          id="city"
          name="city"
          type="text"
          class="col-6"
          label="Cidade"
          data-vv-as="Cidade"
          v-validate="'required'"
          :valid="fields.city && fields.city.valid"
          :error="vErrors.collect('city')"
        />

        <FormControlSelect
          v-model="items.address.state"
          :value="items.address.state"
          ref="address.state"
          id="state"
          name="state"
          type="text"
          class="col-6"
          label="Estado"
          data-vv-as="Estado"
          :options="states"
          v-validate="'required|excluded:Estado'"
          :valid="fields.state && fields.state.valid"
          :error="vErrors.collect('state')"
        />
      </div>

      <div class="row">
        <FormControlCheckbox
          v-model="items.terms"
          class="col-12"
          id="terms"
          name="terms"
          data-vv-as="Termos"
          label="Aceite os termos de adesão às Condições Gerais do Contrato de Gestão de Créditos"
          link="https://valesaudesempre.com.br/condicoes-gerais.pdf"
          linkTitle="Clique aqui para visualizar os termos"
          v-validate="'required'"
          :valid="fields.terms && fields.terms.valid"
          :error="vErrors.collect('terms')"
        />
      </div>

      <div class="telemedicina-container" v-if="hasServiceAdditionals">
        <header class="form-footer">
          <h2 class="form-footer__subtitle">Indique quem terá acesso ao {{ serviceName }}:</h2>
          <div class="row align-center-space">
            <FormControlRadioRefined name="dependents" :options="options" v-model="dependents" />
          </div>
        </header>

        <EinstenFormPerson v-show="dependents.value == 0" :disabled="true" :items="items" />

        <div v-if="dependents.title.includes('dependente')" class="form-dependents">
          <div v-for="(item, index) in items.additionals" :key="index" class="form-content">
            <button
              type="button"
              v-if="items.additionals.length > 1"
              @click="removeAdditional(index)"
              class="form-dependents__remove"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </button>
            <div class="row align-center">
              <h2 class="form-footer__subtitle">Dependente {{ index + 1 }}</h2>
            </div>

            <div class="row">
              <FormControlInput
                class="col-12"
                icon="user"
                v-model.trim="item.name"
                label="Nome completo"
                :id="`additionalName-${index}`"
                :name="`additionalName-${index}`"
                data-vv-as="Nome completo"
                v-validate="!ignoreAdditionals ? 'required' : ''"
                :valid="
                  !vErrors.has(`additionalName-${index}`) &&
                    fields.additionalName &&
                    fields.additionalName.dirty &&
                    fields.additionalName.valid
                "
                :error="vErrors.collect(`additionalName-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlMask
                class="col-6"
                v-model="item.cpf"
                type="tel"
                label="CPF"
                :id="`additionalCpf-${index}`"
                :name="`additionalCpf-${index}`"
                data-vv-as="CPF"
                v-validate="{ required: !ignoreAdditionals, regex: /\d{11}/ }"
                mask="###.###.###-##"
                :valid="
                  !vErrors.has(`additionalCpf-${index}`) &&
                    fields.additionalCpf &&
                    fields.additionalCpf.dirty &&
                    fields.additionalCpf.valid
                "
                :error="vErrors.collect(`additionalCpf-${index}`)"
              />

              <FormControlInput
                class="col-6"
                v-model="item.rg"
                label="RG"
                :id="`additionalRg-${index}`"
                :name="`additionalRg-${index}`"
                data-vv-as="RG"
                v-validate="!ignoreAdditionals ? 'required' : ''"
                :valid="fields.additionalRg && fields.additionalRg.valid"
                :error="vErrors.collect(`additionalRg-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlMask
                class="col-6"
                v-model="item.birth"
                type="tel"
                label="Data de Nascimento"
                :id="`additionalBirth-${index}`"
                :name="`additionalBirth-${index}`"
                data-vv-as="Data de Nascimento"
                v-validate="!ignoreAdditionals ? 'required|date_format:dd/MM/yyyy' : ''"
                :masked="true"
                mask="##/##/####"
                :valid="
                  !vErrors.has(`additionalBirth-${index}`) &&
                    fields.additionalBirth &&
                    fields.additionalBirth.dirty &&
                    fields.additionalBirth.valid
                "
                :error="vErrors.collect(`additionalBirth-${index}`)"
              />

              <FormControlSelect
                class="col-6"
                v-model="item.gender"
                :options="gender"
                :value="item.gender"
                label="Sexo"
                :id="`additionalGender-${index}`"
                :name="`additionalGender-${index}`"
                data-vv-as="Sexo"
                v-validate="!ignoreAdditionals ? 'required' : ''"
                :valid="
                  !vErrors.has(`additionalGender-${index}`) &&
                    fields.additionalGender &&
                    fields.additionalGender.dirty &&
                    fields.additionalGender.valid
                "
                :error="vErrors.collect(`additionalGender-${index}`)"
              />
            </div>

            <div class="row">
              <FormControlInput
                v-model="item.email"
                :id="`additionalEmail-${index}`"
                type="email"
                :name="`additionalEmail-${index}`"
                class="col-6"
                label="E-mail"
                data-vv-as="E-mail"
                icon="envelope"
                v-validate="!ignoreAdditionals ? 'required|email' : ''"
                :valid="
                  !vErrors.has(`additionalEmail-${index}`) &&
                    fields.additionalEmail &&
                    fields.additionalEmail.dirty &&
                    fields.additionalEmail.valid
                "
                :error="vErrors.collect(`additionalEmail-${index}`)"
              />

              <FormControlMask
                v-model="item.mobile"
                :id="`additionalMobile-${index}`"
                type="tel"
                class="col-6"
                label="Celular"
                data-vv-as="Celular"
                :name="`additionalMobile-${index}`"
                icon="phone-alt"
                mask="(##) #####-####"
                v-validate="!ignoreAdditionals ? 'required' : ''"
                :valid="
                  !vErrors.has(`additionalMobile-${index}`) &&
                    fields.additionalMobile &&
                    fields.additionalMobile.dirty &&
                    fields.additionalMobile.valid
                "
                :error="vErrors.collect(`additionalMobile-${index}`)"
              />
            </div>
          </div>

          <div v-if="dependents.title.includes('dependente')" class="row align-center">
            <Button
              v-if="this.items.additionals.length < 3"
              @click.native="addAdditional()"
              type="button"
              class="information-button"
            >
              Adicionar dependente {{ dependentsIndex }}
            </Button>
          </div>
        </div>
      </div>

      <div ref="control" class="control" v-show="hasServiceAdditionals">
        <div class="control-wrap">
          <label>
            <input
              v-model="ignoreAdditionals"
              class="control-checkbox"
              name="cb"
              type="checkbox"
              @change="updateValidation"
            />

            Prefiro incluir os dependentes posteriormente no App Vale Saúde Sempre no botão
            Telemedicina.
          </label>
        </div>
      </div>

      <div class="row align-center">
        <Button
          :disabled="!formValid || !items.terms"
          @click.native="showResume = true"
          type="button"
          >Continuar</Button
        >
      </div>

      <div v-if="vErrors.items.length" class="row align-center control-error">
        <p>Um ou mais campos não foram preenchidos corretamente. Por favor, verifique.</p>
      </div>
    </div>

    <Modal class="dd-m-resume" v-show="showResume && !vErrors.items.length">
      <div class="dd-m-resume-content">
        <h3>Resumo</h3>
        <h4 v-if="hasServiceAdditionals">
          Verifique seus dados e principalmente se incluiu corretamente os dados da pessoa que terá
          acesso ao {{ serviceName }}. Não temos como mudar os dados posteriormente.
          <br />
          O valor da 1ª mensalidade não poderá ser cancelado ou devolvido após você efetuar o
          cadastro.
        </h4>
        <h4 v-if="!hasServiceAdditionals">
          Confirme os dados antes de prosseguir
        </h4>
        <div class="dd-m-resume-content__block">
          <p><span>Nome completo:</span> {{ items.name }}</p>
          <p><span>CPF:</span> {{ items.cpf | cpf }}</p>
          <p><span>RG:</span> {{ items.rg }}</p>
          <p><span>Nascimento:</span> {{ items.birth }}</p>
          <p><span>Sexo:</span> {{ items.gender }}</p>
          <p><span>Telefone:</span> {{ items.phone | tel }}</p>
          <p><span>Celular:</span> {{ items.celphone | mobile }}</p>
          <p><span>E-mail:</span> {{ items.email }}</p>
          <p><span>Endereço:</span> {{ items.address.street }}, {{ items.address.number }}</p>
          <p><span>Bairro:</span> {{ items.address.neighborhood }}</p>
          <p><span>CEP:</span> {{ items.address.cep | cep }}</p>
          <p><span>Cidade:</span> {{ items.address.city }}, {{ items.address.state }}</p>

          <!-- Mostramos se não estiver na Aba "Eu mesmo" e se o usuário não optou por enviar depndentes depois -->
          <div v-if="!dependents.value == 0 || isRequired">
            <p>
              <strong>Quem terá acesso ao {{ serviceName }}:</strong>
            </p>
            <div v-if="!ignoreAdditionals">
              <div class="form-content" v-for="(item, index) in items.additionals" :key="index">
                <p>
                  <strong>Dependente {{ index + 1 }}</strong>
                </p>
                <p><span>Nome completo:</span> {{ item.name }}</p>
                <p><span>CPF:</span> {{ item.cpf | cpf }}</p>
                <p><span>RG:</span> {{ item.rg }}</p>
                <p><span>Nascimento:</span> {{ item.birth }}</p>
                <p><span>Sexo:</span> {{ item.gender }}</p>
                <p><span>E-mail:</span> {{ item.email }}</p>
                <p><span>Celular:</span> {{ item.mobile | mobile }}</p>
              </div>
            </div>
            <div v-else>
              <p>
                Prefiro incluir os dependentes posteriormente no App Vale Saúde Sempre no botão
                Telemedicina.
              </p>
            </div>
          </div>
          <div v-if="!items.additionals.length && hasServiceAdditionals">
            <p>
              <strong>Quem terá acesso ao {{ serviceName }}:</strong>
            </p>
            <p><span>Nome completo:</span> {{ items.name }}</p>
            <p><span>CPF:</span> {{ items.cpf | cpf }}</p>
          </div>
        </div>

        <div class="row align-center">
          <Button class="button--option" @click.native="showResume = false" type="button">
            Editar dados
          </Button>

          <Button
            :disabled="!formValid || !items.terms"
            type="button"
            @click.native="doValidRegister"
          >
            Continuar
          </Button>
        </div>
      </div>
    </Modal>
  </form>
</template>

<script>
import cep from 'cep-promise';
import FormControlInput from './control/FormControlInput.vue';
import FormControlMask from './control/FormControlMask.vue';
import FormControlCheckbox from './control/FormControlCheckbox.vue';
import FormControlRadioRefined from './control/FormControlRadioRefined.vue';
import FormControlSelect from './control/FormControlSelect.vue';
import EinstenFormPerson from './einstein/EinstenFormPerson.vue';
import Button from '../buttons/Button.vue';
import statesJson from '../../data/states.json';
import genderJson from '../../data/gender.json';
import ValidRegister from '../../services/preregister';
import { transformToArray } from '../../utils/error';
import Modal from '../modals/Modal.vue';

const validRegister = new ValidRegister();

export default {
  name: 'FormRegister',
  components: {
    FormControlInput,
    FormControlMask,
    FormControlCheckbox,
    FormControlRadioRefined,
    FormControlSelect,
    Button,
    Modal,
    EinstenFormPerson
  },
  data() {
    return {
      ignoreAdditionals: false,
      dependentsIndex: 2,
      dependents: {
        title: 'Eu mesmo',
        value: 0
      },
      options: [
        { title: 'Eu mesmo', value: 0 },
        { title: 'Eu mesmo + dependente(s)', value: 0 },
        { title: 'Apenas dependente(s)', value: 1 }
      ],
      isRequired: null,
      showResume: false,
      programId: this.$route.params.programId,
      isTelemedicina: sessionStorage.is_telemedicina,
      isOmtSharecare: sessionStorage.is_omt_sharecare,
      isTelemedicinaSharecareIndividual: sessionStorage.is_telemedicina_sharecare_individual,
      isTelemedicinaSharecareFamiliar: sessionStorage.is_telemedicina_sharecare_familiar,
      states: statesJson,
      gender: genderJson,
      items: {
        is_additional: 0,
        cpf: null,
        gender: null,
        address: {
          street: null,
          neighborhood: null,
          city: null,
          state: null,
          complementary: null
        },
        terms: null,
        additionals: [
          {
            name: null,
            cpf: null,
            rg: null,
            birth: null,
            gender: null,
            email: null,
            mobile: null
          }
        ]
      },
      errors: {
        address: {
          zipcode: ''
        }
      }
    };
  },
  watch: {
    dependents(e) {
      this.items.is_additional = e.value;
      this.isRequired = e.title.includes('dependente');
    }
  },
  computed: {
    formValid() {
      return Object.keys(this.fields).every(field => {
        return this.fields[field] && this.fields[field].valid;
      });
    },
    hasServiceAdditionals() {
      return this.isTelemedicina === 'true' || this.isTelemedicinaSharecareFamiliar === 'true';
    },
    serviceName() {
      let name;

      switch (true) {
        case this.isTelemedicina === 'true':
          name = 'Einstein Conecta';
          break;
        case this.isOmtSharecare === 'true':
          name = 'Ligue Saúde';
          break;
        case this.isTelemedicinaSharecareIndividual === 'true':
          name = 'Telemedicina Individual';
          break;
        case this.isTelemedicinaSharecareFamiliar === 'true':
          name = 'Telemedicina Familiar';
          break;
        default:
          name = null;
          break;
      }

      return name;
    }
  },
  mounted() {
    const { key, value } = this.$route.query;
    const restoreData = JSON.parse(sessionStorage.getItem('register'));

    // Preenchimento automático se existirem infos no sessionStorage
    if (restoreData) {
      this.items = restoreData;
    } else if (this.$route.query) {
      // caso contrário, verifica se existem as variaveis em query e preenche
      const { name, cpf, email, mobile } = this.$route.query;
      const { birth_date: birthDate } = this.$route.query;

      if (name && cpf && email && mobile && birthDate) {
        this.items.name = name;
        this.items.cpf = cpf.replace(/\D/, '');
        this.items.email = email;
        this.items.celphone = mobile.replace(/\D/, '');
        this.items.birth = birthDate.replace(/\D/, '');
      }
    }

    if (this.isTelemedicinaSharecareFamiliar === 'true') {
      this.options = [{ title: 'Eu mesmo + dependente(s)', value: 0 }];
      this.dependents = { title: 'Eu mesmo + dependente(s)', value: 0 };
    }

    // Visualização de erro
    setTimeout(() => {
      if (key && value) {
        const field = this.$validator.fields.find({ name: 'email' });
        if (field) {
          this.$validator.errors.add({
            id: field.id,
            field: key,
            msg: value,
            scope: this.$options.scope
          });

          field.setFlags({ valid: false });
        }
      }
    }, 100);
  },
  methods: {
    async updateValidation() {
      this.$nextTick(async () => {
        // Limpamos os dependentes caso usuário opte por enviá-los posteriormente
        if (this.ignoreAdditionals) {
          this.items.additionals = [];
          this.dependentsIndex = 1;
          this.addAdditional();
        }

        await this.$validator.validateAll();
      });
    },
    removeAdditional(index) {
      this.items.additionals.splice(index, 1);
      this.dependentsIndex -= 1;
    },
    addAdditional() {
      const additional = {
        name: null,
        cpf: null,
        rg: null,
        birth: null,
        gender: null,
        email: null,
        mobile: null
      };

      if (this.items.additionals.length < 3) {
        this.items.additionals.push(additional);
        this.dependentsIndex += 1;
      }
    },
    doValidRegister() {
      if (!this.vErrors.items.length) {
        this.$root.$emit('button-loading', true);
        sessionStorage.setItem('register', JSON.stringify(this.items));
        this.items.einstein = sessionStorage.einstein || 0;
        this.items.telemedicina_sharecare_individual =
          sessionStorage.telemedicina_sharecare_individual || 0;
        this.items.telemedicina_sharecare_familiar =
          sessionStorage.telemedicina_sharecare_familiar || 0;
        this.items.omt_sharecare = sessionStorage.omt_sharecare || 0;

        if (!this.items.additionals?.[0]?.name) {
          this.items.additionals = [];
        }

        validRegister
          .doValidRegister(this.programId, this.items)
          .then(res => {
            this.$root.$emit('button-loading', false);
            sessionStorage.setItem('preRegistered', true);
            sessionStorage.setItem('campaign', res.data.data.name);
            sessionStorage.setItem('bank_slip', res.data.data.bank_slip);
            sessionStorage.setItem('credit_card', res.data.data.credit_card);
            sessionStorage.setItem(
              'credit_card_installments',
              res.data.data.credit_card_installments
            );
            sessionStorage.setItem('subscription', res.data.data.subscription);
            sessionStorage.setItem(
              'discounted_subscription',
              res.data.data.discounted_subscription || null
            );
            sessionStorage.setItem('physical_card', res.data.data.physical_card);
            sessionStorage.setItem('physical_card_message', res.data.data.physical_card_message);
            sessionStorage.setItem('pix', res.data.data.pix);

            this.$router.push({
              name: 'selecionar-pagamento'
            });
          })
          .catch(err => {
            this.showResume = false;
            this.$root.$emit('button-loading', false);

            const errors = transformToArray(err);
            const commonErrors = [];

            errors.map(error => {
              const field = this.$validator.fields.find({ name: error.key });
              if (field) {
                this.$validator.errors.add({
                  id: field.id,
                  field: error.key,
                  msg: error.value,
                  scope: this.$options.scope
                });
              } else {
                commonErrors.push(error);
              }
              return error;
            });

            if (commonErrors.length) {
              this.$toaster.error(commonErrors[0].value);
            }
          });
      }
    },
    searchCep(e) {
      if (e) {
        this.disableAddress(true);

        cep(this.items.address.zipcode)
          .then(response => {
            this.items.address = response;
            this.items.address.zipcode = e;
            this.items.address.number = null;

            this.disableAddress(false);
          })
          .catch(() => {
            this.disableAddress(false);
          });
      }
    },
    disableAddress(state) {
      if (state === true) {
        return Object.entries(this.$refs).forEach(item => {
          if (item[0].includes('address')) {
            item[1].$el.querySelector('.control-input').classList.add('disabled');
            item[1].$el.querySelector('.control-input').setAttribute('readonly', 'readonly');
          }
        });
      }

      return Object.entries(this.$refs).forEach(item => {
        if (item[0].includes('address')) {
          item[1].$el.querySelector('.control-input').classList.remove('disabled');
          item[1].$el.querySelector('.control-input').removeAttribute('readonly', 'readonly');
        }
      });
    },
    concatJson(obj1, obj2) {
      const obj = obj1;
      Object.keys(obj2).forEach(key => {
        obj[key] = obj2[key];
      });

      return obj;
    }
  },
  filters: {
    positive(value) {
      if (!value) return 0;

      return value > 0 ? value : 0;
    }
  }
};
</script>

<style lang="scss">
.form-header {
  text-align: center;
  margin-bottom: 24px;
  color: var(--color-positive-normal);

  &__title {
    margin: 0;
    margin-bottom: 8px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__subtitle {
    margin: 0;
    font-weight: 400;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}

.form-footer {
  @extend .form-header;

  &__subtitle {
    @extend .form-header__subtitle;
  }
}

.telemedicina-container {
  margin-left: 0 !important;
  margin-top: 56px;
  margin-bottom: 16px;
}

.dd-m-resume-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  height: 100%;
  padding: 24px 32px;
  background-color: #fff;

  @media (min-width: 1024px) {
    position: relative;
    max-width: 560px;
    box-shadow: 0 8px 24px rgba(#000, 0.1);
    border-radius: 16px;
  }

  &__block {
    background-color: #f1f1f1;
    padding: 12px;
    margin-bottom: 24px;
    border-radius: 8px;
    font-size: 14px;
    height: 320px;
    overflow-y: auto;

    div {
      margin-top: 16px;
    }

    p {
      margin: 0;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    span {
      color: #999;
    }
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
  }

  h4 {
    margin: 0;
    margin-bottom: 24px;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    /*color: #999;*/
  }

  .button {
    margin: 8px;
  }
}

.form-content {
  &:not(:last-child) {
    margin: 32px 0;
  }
}

.form-dependents {
  padding: 32px;
  border-radius: 8px;
  background-color: #f1f1f1;

  .form-content {
    position: relative;
    &:not(:last-child) {
      border-bottom: #eee;
    }
  }

  .button {
    margin: 8px;
  }

  &__remove {
    position: absolute;
    top: 50%;
    right: -48px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 14px;
    border-radius: 50%;
    border: 1px solid var(--color-assertive);
    background-color: #f1f1f1;
    color: var(--color-assertive);

    &:hover {
      background-color: var(--color-assertive);
      color: #fff;
    }
  }
}

.control-wrap label {
  margin: 8px auto 24px;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--color-positive-normal);
}
</style>
